import {
  actionSlotRepository,
  AgentEffectCommands,
  BattleCardProps,
  battleCardsDefRepository,
  ResourceType,
} from "~/business";

export const initBattleCards = () => {
  const {
    spice,
    solaris,
    victoryPoint,
    drawIntrigue,
    water,
    chooseFactionChange,
    or,
    trashCard,
    takeMentatFromAnywhere,
    gainControl,
    multipleFactionChange,
    freighter,
    garnison,
    payResource,
    cause,
  } = AgentEffectCommands;

  const getActionSlot = (slotName: string) => {
    const slotOpt = actionSlotRepository.entities.find(
      (slot) => slot.id === slotName
    );
    if (!slotOpt) {
      throw new Error(
        `init battle cards: could not find an action slot with name ${slotName}`
      );
    }
    return slotOpt;
  };
  const imperialBasin = getActionSlot("Imperial Basin");
  const carthag = getActionSlot("Carthag");
  const arrakeen = getActionSlot("Arrakeen");

  const battleCardDefs: BattleCardProps[] = [
    {
      name: "skirmish",
      level: 1,
      effects: [[victoryPoint(1)], [drawIntrigue, solaris(2)], [solaris(2)]],
    },
    {
      name: "skirmish",
      level: 1,
      effects: [[victoryPoint(1)], [water(1)], [spice(1)]],
    },
    {
      name: "skirmish",
      level: 1,
      effects: [[chooseFactionChange(1), spice(1)], [spice(2)], [spice(1)]],
    },
    {
      name: "skirmish",
      level: 1,
      effects: [
        [chooseFactionChange(1), solaris(2)],
        [solaris(3)],
        [solaris(2)],
      ],
    },
    {
      name: "cloak and dagger",
      level: 2,
      effects: [
        [chooseFactionChange(1), drawIntrigue, drawIntrigue],
        [drawIntrigue, spice(1)],
        [or([drawIntrigue, spice(1)])],
      ],
    },
    {
      name: "chaos",
      level: 2,
      effects: [
        [drawIntrigue, solaris(2), takeMentatFromAnywhere],
        [drawIntrigue, solaris(2)],
        [solaris(2)],
      ],
    },
    {
      name: "imperial basin",
      level: 2,
      controlSlotId: imperialBasin.id,
      effects: [
        [victoryPoint(1), gainControl(imperialBasin)],
        [water(2)],
        [water(1)],
      ],
    },
    {
      name: "terrible purpose",
      level: 2,
      effects: [[victoryPoint(1), trashCard], [water(1), spice(1)], [spice(1)]],
    },
    {
      name: "siege of Arrakeen",
      level: 2,
      controlSlotId: arrakeen.id,
      effects: [
        [victoryPoint(1), gainControl(arrakeen)],
        [solaris(4)],
        [solaris(2)],
      ],
    },
    {
      name: "desert power",
      level: 2,
      effects: [[victoryPoint(1), water(1)], [water(1), spice(1)], [spice(1)]],
    },
    {
      name: "raid stockpiles",
      level: 2,
      effects: [[drawIntrigue, spice(3)], [spice(2)], [spice(1)]],
    },
    {
      name: "guild bank raid",
      level: 2,
      effects: [[solaris(6)], [solaris(4)], [solaris(2)]],
    },
    {
      name: "siege of Carthag",
      level: 2,
      controlSlotId: carthag.id,
      effects: [
        [victoryPoint(1), gainControl(carthag)],
        [drawIntrigue, spice(1)],
        [spice(1)],
      ],
    },
    {
      name: "machinations",
      level: 2,
      effects: [
        [multipleFactionChange({ factionCount: 2, factionUpdate: 1 })],
        [water(1), solaris(2)],
        [water(1)],
      ],
    },
    {
      name: "grand vision",
      level: 3,
      effects: [
        [chooseFactionChange(2), drawIntrigue],
        [drawIntrigue, spice(3)],
        [spice(3)],
      ],
    },
    {
      name: "battle for Carthag",
      level: 3,
      controlSlotId: carthag.id,
      effects: [
        [victoryPoint(2), gainControl(carthag)],
        [drawIntrigue, spice(3)],
        [spice(3)],
      ],
    },
    {
      name: "Imperial basin",
      level: 3,
      controlSlotId: imperialBasin.id,
      effects: [
        [victoryPoint(2), gainControl(imperialBasin)],
        [spice(5)],
        [spice(3)],
      ],
    },
    {
      name: "Battle for Arrakeen",
      level: 3,
      controlSlotId: arrakeen.id,
      effects: [
        [victoryPoint(2), gainControl(arrakeen)],
        [drawIntrigue, spice(2), solaris(3)],
        [drawIntrigue, solaris(2)],
      ],
    },
  ];

  const ixBattleCards: BattleCardProps[] = [
    {
      name: "Skirmish",
      level: 1,
      effects: [[freighter, garnison(1)], [spice(2)], [spice(1)]],
    },
    {
      name: "Skirmish",
      level: 1,
      effects: [[freighter, spice(1)], [solaris(3)], [solaris(2)]],
    },
    {
      name: "Trade Monopoly",
      level: 2,
      effects: [
        [freighter, freighter, garnison(1)],
        [drawIntrigue, water(1)],
        [or([drawIntrigue, water(1)])],
      ],
    },
    {
      name: "Economic Supremacy",
      level: 3,
      effects: [
        [
          victoryPoint(1),
          cause(payResource({ amount: 6, type: ResourceType.Solaris })).effect(
            victoryPoint(1)
          ),
          cause(payResource({ amount: 4, type: ResourceType.Spice })).effect(
            victoryPoint(1)
          ),
        ],
        [victoryPoint(1)],
        [spice(2), solaris(2)],
      ],
    },
  ];

  const filledCards: Omit<BattleCardProps, "id">[] = [
    ...battleCardDefs,
    ...ixBattleCards.map<Omit<BattleCardProps, "id">>((card) => ({
      ...card,
      extension: "Ix",
    })),
  ];

  battleCardsDefRepository.addAll(
    filledCards.map((cardDef, index) => ({
      ...cardDef,
      id: `${index}_${cardDef.name}`,
    }))
  );
  console.debug("init battle cards");
};
